import { Directive, Attribute, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

@Directive({
  selector: '[max][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => JbMaxValidator), multi: true }
  ]
})
export class JbMaxValidator {
  constructor(@Attribute('max') public max: number) { }

  validate(c: FormControl): { [key: string]: any } {
    return c.value <= this.max ? null : {
      max: {
        valid: false
      }
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/form/validators/max.validator.ts